import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import Notifications from "vue-notification";
import VueCookies from "vue-cookies";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import { getImage, getWebImage } from "./services/getImage";
import { secondServise } from "./services/_shared/time-servise";
import { curentIndex, getLocale, givenLocale } from "./services/getCurentIndex";
import { deleteImages } from "@/api/delite/delite-element";
import {
  getCoast,
  resolveCurrencySymbol,
} from "@/services/_shared/coast-formation";
import axiosApiInstance from "@/api/AuthAPI/auth-request-api";
import { log_info } from "@/services/log/log";
import {
  accessPermissions,
  getRootPermition,
  getRight,
} from "./services/accessDecoder";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@/assets/styles/bootstrap-custom.scss";
import "bootstrap/js/dist/offcanvas.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "@/assets/styles/bages.scss";
import "@/assets/styles/draggable.scss";
import "@/assets/styles/hover.scss";
import "@/assets/styles/config-options.scss";

Vue.use(Notifications);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueCookies);

Vue.config.productionTip = false;

Vue.prototype.$second = secondServise;
Vue.prototype.$getImage = getImage;
Vue.prototype.$getWebImage = getWebImage;
Vue.prototype.$getLocalImage = getImage;
Vue.prototype.$getRemoteImage = getWebImage;
Vue.prototype.$getLocale = getLocale;
Vue.prototype.$givenLocale = givenLocale;
Vue.prototype.$getLocaleIndex = curentIndex;
Vue.prototype.$accessPermissions = accessPermissions;
Vue.prototype.$deliteImage = deleteImages;
Vue.prototype.$getRootPermition = getRootPermition;
Vue.prototype.$isRoot = getRootPermition;
Vue.prototype.$getCoast = getCoast;
Vue.prototype.$currencySymbol = resolveCurrencySymbol;
Vue.prototype.$getRight = getRight;
Vue.prototype.$axios = axiosApiInstance;
Vue.prototype.$log_info = log_info;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
